import React from 'react';
import MaterialModal from '@material-ui/core/Dialog';

export default ({
  children,
  paperClassName,
  isOpen,
  onClose,
  fullWidth = true,
}) => (
  <MaterialModal
    classes={{ paper: paperClassName }}
    open={isOpen}
    onClose={onClose}
    fullWidth={fullWidth}
  >
    {children}
  </MaterialModal>
);
